import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { runInAction } from 'mobx'

import { ReactiveTabs } from '../ReactiveTabs'
import { MyProductsTable } from '../MyProductsTable'
import { MyProductsFilter } from '../MyProductsFilter'
import { ProductsTabTitle } from '../ProductsTabTitle'
import { StoreProductsTable } from '../StoreProductsTable'
import { MyProductsTopPagination } from '../MyProductsTopPagination'

import { useStoreRoute } from '../../hooks/routeHooks'
import { useLogic, useStore } from '../../hooks/storeHook'

import { MyProductState } from '../../server/mpsklad_core/Models/MyProductState'

const appBarProps = {elevation: 1}

export const ProductsScreenTable =
  observer(() => {
    const storeRoute = useStoreRoute()

    const {productStore} = useStore()
    const {myProductsInfo, myStateTab} = productStore

    const logic = useLogic()

    useEffect(() => {
      runInAction(() => {
        productStore.myStateTab = MyProductState.Active
        productStore.storeMountState = storeRoute
      })

      return () => {
        productStore.storeMountState = null
      }
    }, [storeRoute, productStore])

    useEffect(() => {
        if (storeRoute && productStore.storeMountState) {
          setTimeout(logic.reloadMyProductsInfo, 50)
        }
      },
      [storeRoute, productStore, logic])

    const tabs = useMemo(() => [{
        value: MyProductState.Active,
        title: <ProductsTabTitle title="Активные товары" count={myProductsInfo?.activeCount}/>
      }, {
        value: MyProductState.New,
        title: <ProductsTabTitle title="Не сопоставлено" count={myProductsInfo?.newCount}/>
      }, {
        value: MyProductState.Error,
        title: <ProductsTabTitle title="Товары с ошибками" count={myProductsInfo?.errorCount}/>
      }, {
        value: MyProductState.FromMarketplace,
        title: <ProductsTabTitle title="C маркетплейсов" count={myProductsInfo?.fromMarketplaceCount}/>
      }],
      [myProductsInfo])

    if (!storeRoute) {
      return null
    }

    return (
      <ReactiveTabs
        tabs={tabs}
        value={myStateTab}
        onChange={newTab => productStore.myStateTab = newTab}
        appBarProps={appBarProps}
        AfterTabsComponent={
          myStateTab === MyProductState.FromMarketplace
          ? undefined
          : MyProductsTopPagination
        }>
        {
          myStateTab === MyProductState.FromMarketplace
          ? <StoreProductsTable/>
          : <>
            <div className="body_wrapper">
              <MyProductsFilter/>
            </div>

            <MyProductsTable/>
          </>
        }
      </ReactiveTabs>
    )
  })